const isClientError = (err) => {
  return Boolean(
    err && err.response && err.response.status >= 400 && err.response.status < 500
  )
}

export default isClientError
